import type { StoreUser } from "./api";

export function hasStorePermission(user: StoreUser | null, key: string) {
  return Boolean(user?.Permissions?.includes(key));
}
